import { render } from "./BudgetAllocated.vue?vue&type=template&id=a72eabac"
import script from "./BudgetAllocated.vue?vue&type=script&setup=true&lang=js"
export * from "./BudgetAllocated.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"scripts/governance/BudgetAllocated.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a72eabac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a72eabac', __exports__)) {
    api.reload('a72eabac', __exports__)
  }
  
  module.hot.accept("./BudgetAllocated.vue?vue&type=template&id=a72eabac", () => {
    api.rerender('a72eabac', render)
  })

}


export default __exports__